import Immutable from 'immutable';
import * as ActionTypes from '../constants/ActionTypes';

let initialState = Immutable.Map();

export default function overviewChart(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.INSTRUMENT_REQUEST_DATA:
      return state.setIn([action.itemSector, 'isFetching'], true);
    case ActionTypes.INSTRUMENT_RECEIVE_DATA:
      state = state.mergeIn([action.itemSector], Immutable.fromJS(action.data));
      return state.setIn([action.itemSector, 'isFetching'], false);
    default:
      return state;
  }
}
